import type { DialogueLine } from './types'

export const DIALOGUE_MOVEMENT_BEHAVIORS = [
  'continue', 'none', 'approach', 'follow_route', 'face_target',
] as const

export const DIALOGUE_ATTENTION_STYLES = [
  '', 'none', 'casual', 'direct', 'group',
] as const

export const DIALOGUE_BODY_TURNING_BEHAVIORS = [
  '', 'none', 'head_only', 'partial', 'full_body',
] as const

export const DIALOGUE_SPEAKER_INTERRUPTED_BEHAVIORS = [
  '', 'continue', 'retry', 'skip', 'stop',
] as const

export const DIALOGUE_TARGET_LEAVES_BEHAVIORS = [
  '', 'continue', 'shorten', 'pause', 'end_naturally', 'stop', 'retarget',
] as const

export const DIALOGUE_GESTURE_IDS = [
  'swing',
  'swing_main_hand',
  'wave',
  'swing_off_hand',
  'critical_hit',
  'magic_critical_hit',
] as const

export const DIALOGUE_SPEAKER_ROLES = [
  '', 'citizen', 'merchant', 'guard', 'worker', 'chef', 'waiter', 'performer',
  'musician', 'visitor', 'child', 'elder', 'night_worker', 'street_vendor',
  'restaurant_customer', 'stage_audience_member', 'background_resident', 'custom',
] as const

export function dialogueTargetLabel(line: DialogueLine): string {
  switch (line.intendedTargetType) {
    case 'none': return 'No authored target'
    case 'player': return 'Direct player'
    case 'npc': return `NPC ${line.intendedTarget}`
    case 'group': return `Group ${line.intendedTarget}`
    case 'focus_point': return `Focus point ${line.intendedTarget}`
  }
}
